export default "__VITE_ASSET__DMJ5RNSc__"